/**
 * Service-worker teardown.
 *
 * ⚠️ This is NOT dead CRA scaffolding — `unregister()` is called on every boot from `src/index.jsx`
 * and does real work. This build emits no `service-worker.js`, and the host rewrites unknown paths
 * to `index.html`, so any worker still registered from an earlier build fails to update with
 * "unsupported MIME type ('text/html')". `unregister()` tears that stale worker down and suppresses
 * the error. Deleting this file would strip an active fix, not clean up cruft.
 *
 * The generated `register()` half (plus `registerValidSW` / `checkValidServiceWorker`) has been
 * removed: nothing called it, and it was the file's only use of `process.env.PUBLIC_URL` — a
 * Create-React-App-specific variable with no Vite equivalent, which would have resolved to
 * `undefined` and thrown inside `new URL(...)` had anything ever invoked it.
 *
 * Restore a `register()` only alongside a real service-worker build, and source its URL from
 * `import.meta.env.BASE_URL` rather than PUBLIC_URL.
 */
export function unregister() {
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.ready.then((registration) => {
			registration.unregister();
		});
	}
}
